"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
exports.typography = function (t) {
    return {
        h1: {
            fontWeight: 500,
            fontSize: '2.488rem',
            letterSpacing: '-0.24px',
            color: t.text.primary,
        },
        h2: {
            fontWeight: 500,
            fontSize: '2.074rem',
            letterSpacing: '-0.24px',
            color: t.text.primary,
        },
        h3: {
            fontWeight: 500,
            fontSize: '1.728rem',
            letterSpacing: '-0.06px',
            color: t.text.primary,
        },
        h4: {
            fontWeight: 500,
            fontSize: '1.44rem',
            letterSpacing: '-0.06px',
            color: t.text.primary,
        },
        h5: {
            fontWeight: 500,
            fontSize: '1.2rem',
            letterSpacing: '-0.05px',
            color: t.text.primary,
        },
        h6: {
            fontWeight: 500,
            fontSize: '1rem',
            letterSpacing: '-0.05px',
            color: t.text.primary,
        },
        body1: {
            color: t.text.primary,
        },
        body2: {
            color: t.text.secondary,
        },
        overline: {
            fontWeight: 500
        }
    };
};
//# sourceMappingURL=typography.js.map